import {
	POSITION_INLINE,
	POSITION_LEFT,
	POSITION_RIGHT,
	POSITION_CENTER,
	SIZE_ORIGINAL,
	IMAGE_MARGIN
} from '@techchange/pm-specs/src/specs/nodes/image.js';

import {
	buildImageSrcSet,
	buildImageSizes,
	resizeImage,
	IMAGE_WIDTHS,
} from '@techchange/filestack';

import editorStyles from '../../TextEditor.module.scss';

/**
 * NodeView implementation for image nodes. Handles dom styling
 * based on image node attributes and selection state.
 */
class ImageView {

	constructor(node, view) {

		this.node = node;
		this.view = view;

		// Set up image
		const { src, alt, title, size, position } = node.attrs;

		this.dom = document.createElement('img');

		// Process image as needed
		const processedSrc = resizeImage(src);

		// Get responsive attributes
		const srcSet = buildImageSrcSet(src, IMAGE_WIDTHS);
		const sizes = srcSet && buildImageSizes(size);

		// Don't add responsive attributes when editing or if original size is selected
		if (!view.editable && size !== SIZE_ORIGINAL && srcSet && sizes) {

			this.dom.srcset = srcSet;
			this.dom.sizes = srcSet && buildImageSizes(size);

		}

		// Add standard attributes
		this.dom.src = processedSrc;
		this.dom.alt = alt;
		this.dom.title = title;

		this.dom.style.width = size;

		if (position === POSITION_INLINE) {

			this.dom.style.display = 'inline';

		} else if (position === POSITION_CENTER) {

			this.dom.style.display = 'block';
			this.dom.style.margin = `${IMAGE_MARGIN} auto`;

		} else if (position === POSITION_LEFT) {

			this.dom.style.float = POSITION_LEFT;
			this.dom.style.margin = `${IMAGE_MARGIN} ${IMAGE_MARGIN} ${IMAGE_MARGIN} 0px`;

		} else if (position === POSITION_RIGHT) {

			this.dom.style.float = POSITION_RIGHT;
			this.dom.style.margin = `${IMAGE_MARGIN} 0px ${IMAGE_MARGIN} ${IMAGE_MARGIN}`;

		}

		// Disable drag events
		this.dom.ondragstart = () => false;

	}

	update(node) {

		if (this.view.editable) {

			Object.keys(node.attrs).forEach((attr) => {

				// Update dom styling given attribute changes
				if (node.attrs[attr] !== this.node.attrs[attr]) {

					if (attr === 'size') {

						this.dom.style.width = node.attrs.size;

					} else if (attr === 'position') {

						const newPosition = node.attrs.position;

						if (newPosition === POSITION_INLINE) {

							this.dom.style.display = 'inline';
							this.dom.style.float = '';
							this.dom.style.margin = '';

						} else if (newPosition === POSITION_CENTER) {

							this.dom.style.display = 'block';
							this.dom.style.float = '';
							this.dom.style.margin = `${IMAGE_MARGIN} auto`;

						} else if (newPosition === POSITION_LEFT) {

							this.dom.style.display = 'inline';
							this.dom.style.float = POSITION_LEFT;
							this.dom.style.margin = `${IMAGE_MARGIN} ${IMAGE_MARGIN} ${IMAGE_MARGIN} 0px`;

						} else if (newPosition === POSITION_RIGHT) {

							this.dom.style.display = 'inline';
							this.dom.style.float = POSITION_RIGHT;
							this.dom.style.margin = `${IMAGE_MARGIN} 0px ${IMAGE_MARGIN} ${IMAGE_MARGIN}`;

						}

					} else {

						this.dom[attr] = node.attrs[attr];

					}

				}

			});

			this.node = node;

		}

		return true;

	}

	selectNode() {

		this.dom.className = editorStyles.selected;

	}

	deselectNode() {

		this.dom.className = '';

	}

}

export default ImageView;
